import Keycloak from "keycloak-js";

export const keycloakInstance = Keycloak({
    realm: process.env.REACT_APP_KEYCLOAK_REALM || "Caia",
    url: process.env.REACT_APP_KEYCLOAK_URL || "https://auth.ia.parts/auth/",
    clientId: "react-web-app",
});
